<template>
    <el-select
        :loading="loading"
        :remote-method="remoteMethod"
        :value="value"
        @change="onChange"
        filterable
        multiple
        placeholder="Search community..."
        remote
        reserve-keyword
    >
        <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in computedOptions"
        >
        </el-option>
    </el-select>
</template>

<script>
import qs from "qs";

export default {
    props: ["value", "initialOptions"],
    data() {
        return {
            options: [],
            loading: false,
            cachedOptions: [],
        };
    },
    mounted() {
        if (this.initialOptions) {
            this.options = this.initialOptions;
            this.cachedOptions = this.initialOptions;
        }
    },
    computed: {
        computedOptions() {
            let options = this.options;
            _.forEach(this.value, (id) => {
                if (_.find(options, { id })) {
                    return;
                }
                let option = _.find(this.cachedOptions, { id });
                if (option) {
                    options.push(option);
                }
            });
            return options;
        },
    },
    methods: {
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                let params = {
                    filter: {
                        name: query,
                    },
                };
                axios
                    .get(`/web-api/community?${qs.stringify(params)}`)
                    .then((response) => {
                        this.options = response.data.data;
                        _.forEach(this.options, (comm) => {
                            if (!_.find(this.cachedOptions, { id: comm.id })) {
                                this.cachedOptions.push(comm);
                            }
                        });
                    })
                    .finally(() => (this.loading = false));
            } else {
                this.options = [];
            }
        },
        onChange(e) {
            this.$emit("input", e);
        },
    },
};
</script>

<style scoped></style>
